import React from "react";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bubble } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import { Button } from "rsuite";
import annotationPlugin from "chartjs-plugin-annotation";
import {
  numberFormatter,
  numberFormatterForCPGraph,
  setTicks,
} from "../../utils";
import { ReferenceArea } from "recharts";

ChartJS.register(
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  zoomPlugin,
  annotationPlugin
);

let maxx = 20;
let minn = 20;
// const dragColor = Utils.randomColor(0.4);
const zoomOptions = {
  pan: {
    enabled: true,
    mode: "xy",
    modifierKey: "ctrl",
  },
  zoom: {
    mode: "xy",
    drag: {
      enabled: true,
      borderColor: "rgb(54, 162, 235)",
      borderWidth: 1,
      backgroundColor: "rgba(54, 162, 235, 0.3)",
    },
  },
};

export function BubbleScatterWithZoom(props: any) {
  // console.log("props", props);
  let graphData: any = [];
  let labels: any = [];
  let backgroundColor: any = [];
  let borderColor: any = [];
  let priceList : any = [];
  let YscaleMax :any = 0;
  let YscaleMin : any = 0;
  let max = 0;

  let yTicks = setTicks(props.minYAxis, props.maxYAxis);
  // console.log(yTicks);
  // const domain= {([dataMin : any, dataMax : any]) => {
  //   const divFactor = dataMax > 100 ? 20 : 10;
  //   return [Math.floor(Math.min(dataMin) / divFactor) * divFactor, Math.ceil(dataMax / divFactor) * (divFactor)];
  //   }}

  const domain = (dataMin: any, dataMax: any) => {
    const divFactor = dataMax > 100 ? 20 : 10;
    return [Math.floor(Math.min(dataMin) / divFactor) * divFactor, Math.ceil(dataMax / divFactor) * (divFactor)];
  }

  // console.log(
  //   domain(props.minYAxis, props.maxYAxis)
  // );
  props.data.map((d: any) => {
    if (Number(d.volume) > max) {
      max = Number(d.volume);
    }
  });

  const generateRandomColour = () => {
    var x = Math.floor(Math.random() * 256);
    var y = Math.floor(Math.random() * 256);
    var z = Math.floor(Math.random() * 256);
    var bgColor = "rgb(" + x + "," + y + "," + z + ")";
    return bgColor;
  };
  let colour: any = {};
  if (props.selectedCustomerData?.Customer_Class !== "NA") {
    colour = { [props.selectedCustomerData?.Customer_Class]: "yellow" };
  }

  props.data.map((d: any) => {
    priceList.push(d.price)
    priceList.push(d.peerPrice)
    priceList.push(d.five)
    priceList.push(d.fifty)
    priceList.push(d.twentyFive)
    // console.log('***Graph***', { x: 27, y: d.price, r: (d.revenue / max) * 5 + 5 });
    graphData.push({ x: maxx, y: d.price, r: 10 });
    labels.push(d.name);
    if (d.customer === props.selectedCustomerData?.customer) {
      backgroundColor.push(d.color);
      borderColor.push("#fff");
      } else if (props.selectedCustomerData?.Customer_Class !== "NA") {
      if (!colour[d?.Customer_Class]) {
        // colour[d?.Customer_Class] = generateRandomColour();
        colour[d?.Customer_Class] = d.color;
      }
      
      backgroundColor.push(d.color);
      borderColor.push(d.color);
    } else {
      backgroundColor.push("white");
      borderColor.push("white");
      // borderColor.push("rgba(255, 255, 255, 0)")
      }
      });

      YscaleMax = Math.max(...priceList)
      YscaleMin = Math.min(...priceList)

      // console.log(YscaleMax + 0.05, YscaleMin + 0.05 ,YscaleMax ,YscaleMin);
      
      

  const data: any = {
    labels: labels,
    datasets: [
      {
        data: graphData,
        backgroundColor: backgroundColor,
        borderColor: borderColor,

      },
    ],
  };


  const findClosestIndex = (yAxisArr: any, ReferenceLine: any) => {
    let closestIndex = 0;
    let smallestDifference = Math.abs(yAxisArr[0] - ReferenceLine);
    for (let index = 0; index < yAxisArr.length; index++) {
      let currentDifference = Math.abs(yAxisArr[index] - ReferenceLine);
      if (currentDifference < smallestDifference) {
        smallestDifference = currentDifference;
        closestIndex = index;
      }
    }
    return closestIndex;
  };

  const options: any = {
    onClick: function (e: any) {
      props.handleClick(props.data[e.chart._active[0].index], true);
    },
    maintainAspectRatio: false,
    plugins: {
      annotation: {
        annotations: {
          line1: {
            display: props.referenceLine !== null ? true : false,
            type: "line",
            drawTime: "beforeDatasetsDraw",
            yMin: props.referenceLine,
            yMax: props.referenceLine,
            // xMin: minn,
            // xMax : maxx,
            xMin: 4,
            xMax: props.openPopup ? 35 : props?.index ? 100 : 35,
            // xMin: 17,
            // xMax: props.openPopup ? 38.3 : props?.index ? 100 : 37.3,
            borderWidth: 3,
            borderColor: "rgba(255, 99, 132, 0.5)",
            borderDash: [5, 5],
            enter: function ({ element }: { element: any }) {
              element.label.options.display = true;
              return true;
            },
            // leave: function({ element }: { element: any }) {
            //   element.label.options.display = false;
            //   return true;
            // },
            label: {
              display: true,
              xAdjust: 30,
              content: "$" + props?.referenceLine,
              position: "end",
              font: {
                size: 14
              }
            },
          },
          line2: {
            display: props.selectedCustomerData.five !== null ? true : false,
            type: "line",
            drawTime: "beforeDatasetsDraw",
            yMin: props.selectedCustomerData.five,
            yMax: props.selectedCustomerData.five,
            // yMin: 5.0,
            // yMax: 5.0,
            xMin: 4,
            xMax: props.openPopup ? 35 : props?.index ? 100 : 35,
            // xMax : maxx,
            // xMin: 17,
            borderWidth: 3,
            borderColor: "#289c45",
            borderDash: [8, 8],
            enter: function ({ element }: { element: any }) {
              element.label.options.display = true;
              return true;
            },
            leave: function ({ element }: { element: any }) {
              element.label.options.display = false;
              return true;
            },
            label: {
              display: false,
              xAdjust: 30,
              content: "5th:" + props?.selectedCustomerData.five,
              position: "end",
              font: {
                size: 14
              }
            },
          },
          line3: {
            display:
              props.selectedCustomerData.twentyFive !== null ? true : false,
            type: "line",
            drawTime: "beforeDatasetsDraw",
            yMin: props.selectedCustomerData.twentyFive,
            yMax: props.selectedCustomerData.twentyFive,
            // yMin: 5.0,
            // yMax: 5.0,
            enter: function ({ element }: { element: any }) {
              element.label.options.display = true;
              return true;
            },
            leave: function ({ element }: { element: any }) {
              element.label.options.display = false;
              return true;
            },
            xMin: 4,
            xMax: props.openPopup ? 35 : props?.index ? 100 : 35,
            borderWidth: 3,
            borderColor: "#3a7048",
            borderDash: [5, 5],
            label: {
              display: false,
              xAdjust: -30,
              content: "25th:" + props?.selectedCustomerData.twentyFive,
              position: "start",
              font: {
                size: 14
              }
            },
          },
          line4: {
            display: props.selectedCustomerData.fifty !== null ? true : false,
            type: "line",
            drawTime: "beforeDatasetsDraw",
            yMin: props.selectedCustomerData.fifty,
            yMax: props.selectedCustomerData.fifty,
            // yMin: 5.0,
            // yMax: 5.0,
            enter: function ({ element }: { element: any }) {
              element.label.options.display = true;
              return true;
              },
              leave: function ({ element }: { element: any }) {
                element.label.options.display = false;
                return true;
                },
                xMin: 4,
                xMax: props.openPopup ? 35 : props?.index ? 100 : 35,
                borderWidth: 3,
                borderColor: "#344d3a",
               
                label: {
                  display: false,
                  xAdjust: -30,
              content: "50th:" + props?.selectedCustomerData.fifty,
              position: "start",
              font: {
                size: 14
                }
                },
                },

               
                box1: {
            type: "box",
            drawTime: "beforeDatasetsDraw",
            // xmax : maxx,
            xMin: props?.index ? (props?.index == 0 ? 0 : 5) : 4,
            xMax: props?.index ? (props?.index == 0 ? 100 : 100) : 35,
            yMin: yTicks[0],
            yMax: yTicks[findClosestIndex(yTicks, props.referenceLine) + 5],
            // yMax: props.referenceLine +  props.referenceLine * 0.1 ,
            borderWidth: 0,
            borderColor: "white",
            backgroundColor: "rgba(102,102,102,0.3)",
          },
        },
      },
      zoom: zoomOptions,
      tooltip: {
        callbacks: {
          title: (context: any) => {
            let element = props.data[context[0].dataIndex];
            return "Customer: " + element.customerDesc.split(" ").join("\n");
          },
          label: function (context: any) {
            let element = props.data[context.dataIndex];
            return [
              "Project Flag : " + element.project_flag,
              "Price: $" + numberFormatter(element.price, 2),
              "Qty Purchased: " + element.volume,
              "Revenue: " + "$" + numberFormatter(element.revenue, 2),
              "Quadrant : " + "\n" + element?.quadrant,
            ];
          },

          labelTextColor: function (context: any) {
            return "#d3d3d3";
          },
        },
        displayColors: false,
        backgroundColor: "#333333",
      },
      legend: {
        display: false,
        labels: {
          usePointStyle: true,
          boxWidth: 5,
          boxHeight: 5,
          color: "yellow",
        },
        position: "bottom",
        align: "end",
      },
    },
    scales: {
      x: {
        offset: true,
        display: false,
        // display: true,
        border: {
          color: "white",
        },
        // beginAtZero: true,
        //max: props.xAxisRange.maxRange+10,
        title: {
          display: true,
          text: "Vol/Drop",
          color: "white",
        },
        grid: {
          display: false,
        },
        ticks: {
          display: false,
          min: minn,
          max: maxx,
          // max:xTicks[xTicks.length-1],
          maxTicksLimit: 4,
          callback: function (val: any) {
            return numberFormatterForCPGraph(Math.exp(val), 0);
          },
          color: "white",
        },
      },
        y: {

        suggestedMin: YscaleMin ,
        suggestedMax: YscaleMax * 0.2 ,

        beginAtZero: false,
        //max: props.yAxisRange.maxRange+10,
        title: {
          display: props?.index === 0 ? true : !props?.index ? true : false,
          text: "Price/Unit($)",
          color: "white",
        },
        grid: {
          display: false,
        },
        ticks: {
          display: props?.index === 0 ? true : !props?.index ? true : false,
          // maxTicksLimit: 4,
          
          color: "white",
          font: {
            size: 16, // set the font size for x-axis labels
          },
          autoSkip: true, 
          maxTicksLimit: 5, 

          // min: yTicks[0],

          // stepSize: 1,
          // max: yTicks[findClosestIndex(yTicks , props.referenceLine) * 1.2],
          // yMax: props.referenceLine + props.referenceLine * 0.1,
          callback: function (value: any) {
            return "$" + value.toFixed(2);
          },
        },
      },
    },
  };

  const chartRef: any = React.useRef(null);

  const handleResetZoom = () => {
    if (chartRef && chartRef.current) {
      chartRef.current.resetZoom();
    }
  };

  return (
    <div style={{ height: "35vh", borderRight: "2px dotted #a4f504" }}>
      <Button
        onClick={handleResetZoom}
        style={{
          color: "white", background: "#a4f504b0",    left: "45%"
         , fontSize: props.openPopup ? "14px" : "14px" ,borderRadius : "0px",
        }}
        appearance="default"
        size="sm"
      >
        Reset Zoom
      </Button>
      <Bubble
        // height={500}
        ref={chartRef}
        options={options}
        data={data}
      />
    </div>
  );
}
